var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 505,
    height: 321,
    viewBox: "0 0 505 321",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.792 115.125H217.208C211.639 115.125 207.125 119.639 207.125 125.208V195.792C207.125 201.361 211.639 205.875 217.208 205.875H287.792C293.361 205.875 297.875 201.361 297.875 195.792V125.208C297.875 119.639 293.361 115.125 287.792 115.125Z",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.854 150.417C239.031 150.417 242.417 147.031 242.417 142.854C242.417 138.678 239.031 135.292 234.854 135.292C230.678 135.292 227.292 138.678 227.292 142.854C227.292 147.031 230.678 150.417 234.854 150.417Z",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.875 175.625L272.667 150.417L217.208 205.875",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.8b1315ca2b3510bb5811ad3a2c0004f1.svg";
export { ForwardRef as ReactComponent };